import React from 'react';
import { PropTypes } from 'prop-types';

import Modal from 'components/layout/Modal';

import Header from 'components/ModalFaqs/Sections/Header';
import Footer from 'components/ModalFaqs/Sections/Footer';
import FaqsWithMarkup from 'components/ModalFaqs/Sections/FaqsWithMarkup';

const ModalFaqs = ({ handleClose, t }) => {
  const renderHeader = () => <Header onClose={handleClose} t={t} />;

  return (
    <Modal
      show
      size="M"
      closeButton={false}
      withPadding={false}
      onClose={handleClose}
      renderHeader={renderHeader}
      sticky
    >
      <div>
        <FaqsWithMarkup />

        <Footer />
      </div>
    </Modal>
  );
};

ModalFaqs.propTypes = {
  handleClose: PropTypes.func,
  t: PropTypes.func,
  order: PropTypes.any.isRequired,
  loads: PropTypes.any.isRequired,
};

ModalFaqs.defaultProps = {
  handleClose: () => ({}),
  t: (t) => t,
};

export default ModalFaqs;
